import { Fragment, useContext, useEffect, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { useSignIn, useIsAuthenticated } from "react-auth-kit";
import { sendApiRequest } from "../../services/Base/base-service";

import RecoverPasswordModal from "../Modals/RecoverPasswordModal";
import UserContext from "../../store/user-context";
import {
  Form,
  FormGroup,
  Input,
  Button,
  Toggle,
  Icon,
  Alert,
  Spinner,
} from "design-react-kit";

import logo from "../../assets/logo.svg";
import classes from "../../assets/LoginForm.module.css";
import secureLocalStorage from "react-secure-storage";
import FormsFooter from "../FormsFooter";

const LoginForm = () => {
  const [error, setError] = useState(null);
  const [modalOpen, setModalOpen] = useState(false);
  const [rememberMe, setRememberMe] = useState(false);
  const [isLoading, setIsLoading] = useState(false);

  const navigate = useNavigate();
  const signIn = useSignIn();

  const isAuthenticated = useIsAuthenticated();

  const userContext = useContext(UserContext);

  useEffect(() => {
    if (isAuthenticated()) {
      navigate("/");
    }
  });

  const toggleVisibilityHandler = () => {
    const input = document.getElementById("password");
    if (input.type === "password") {
      input.type = "text";
    } else {
      input.type = "password";
    }
  };

  const modalCloseHandler = () => {
    setModalOpen(false);
  };

  const loginHandler = (e) => {
    e.preventDefault();
    setError(null);
    setIsLoading(true);
    const username = document.getElementById("email").value;
    const password = document.getElementById("password").value;

    sendApiRequest(
      "Authentication/Login",
      "POST",
      false,
      { username, password, rememberMe },
      signIn,
      null,
      navigate
    ).then((response) => {
      if (response.errors !== null) {
        setError(response.errors);
        setIsLoading(false);
      } else {
        secureLocalStorage.setItem("rememberMe", rememberMe);
        userContext.setUserId(response.data.userId);
        userContext.setUserEmail(response.data.userEmail);
        userContext.setIsAdmin(response.data.userRole);
        userContext.setTwoFactorAuthResendToken(
          response.data.twoFactorAuthResendToken
        );
        if (response.data.selectedClient !== null) {
          userContext.setSelectedClientFiscalCode(
            response.data.selectedClient.fiscalCode
          );
          userContext.setSelectedClientName(response.data.selectedClient.name);
          userContext.setSelectedClientTwoFactorEnabled(
            response.data.selectedClient.twoFactorEnabled
          );
        }
        setIsLoading(false);
        if (response.data.token === "") {
          navigate("/login-mfa");
        }
      }
    });
  };

  return (
    <Fragment>
      <div className={classes["login-wrapper"]}>
        <div className={classes["left-side"]}>
          <img src={logo} alt="Logo" className={classes.logo} />
        </div>
        <div className={classes["right-side"]}>
          <div className="d-flex flex-column align-items-start mx-auto">
            <h4 className="text-center mt-3">Accedi su EasyNotification</h4>
            <p>Inserisci i tuoi dati</p>
          </div>
          {error !== null && error.length !== undefined && (
            <Alert color="danger" className="w-50 ml-auto mr-auto">
              {error.map((item) => (
                <p key={item}>{item}</p>
              ))}
            </Alert>
          )}

          <Form className="mr-auto ml-auto">
            {isLoading && (
              <p
                style={{
                  height: "50px",
                  position: "relative",
                  marginBottom: "3rem",
                }}
              >
                <Spinner double active />
              </p>
            )}
            <div className="form-row">
              <FormGroup className="col-sm-12 m-0">
                <Input
                  id="email"
                  type="text"
                  label="Email"
                  placeholder="Inserisci email"
                  autoComplete="email"
                />
              </FormGroup>
            </div>
            <div className="form-row">
              <FormGroup className="col-sm-12 m-0 position-relative">
                <Input
                  id="password"
                  type="password"
                  label="Password"
                  placeholder="Inserisci password"
                />
                <Icon
                  icon="it-password-visible"
                  className={classes.eye}
                  onClick={toggleVisibilityHandler}
                  fill="#005A9A"
                />
              </FormGroup>
            </div>
            <FormGroup
              check
              className="form-check-group d-flex align-items-center justify-content-start save"
            >
              <Toggle
                id="rememberMe"
                onChange={(e) => setRememberMe(e.target.checked)}
              />
              <span className="mb-2">
                Ricorda le credenziali di accesso per 30 giorni
              </span>
            </FormGroup>
            <FormGroup className="col-sm-12 mb-2 d-flex align-items-center justify-content-between">
              <div>
                <Link to={null} className="d-block">
                  Non riesci ad accedere?
                </Link>
                <Link
                  to={null}
                  className="d-block"
                  onClick={(e) => setModalOpen(true)}
                >
                  Recupera le tue credenziali
                </Link>
              </div>
              <Button
                color="primary"
                type="submit"
                onClick={(e) => loginHandler(e)}
              >
                Accedi
              </Button>
            </FormGroup>
          </Form>
          <FormsFooter classes={classes} />
        </div>
      </div>
      <RecoverPasswordModal
        modalOpen={modalOpen}
        modalCloseHandler={modalCloseHandler}
      />
    </Fragment>
  );
};

export default LoginForm;
